import { render, staticRenderFns } from "./GetArea.vue?vue&type=template&id=cd99456a"
import script from "./GetArea.vue?vue&type=script&lang=js"
export * from "./GetArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports